<div class="questionWrapper" *ngIf="showComponent">
  <span class='questionHeader'>
    <span class='questionNumberText' [innerHTML]="questionData.numberText"></span>
    <span class='questionText' [innerHTML]="questionData.text"></span>
  </span>
  <div class="p-grid answersGrid">
    <!-- <ng-container *ngFor="let selectedCategoryAnswerOption of selectedCategoryAnswerOptionList; index as i"> -->
      <div class="p-col-12 p-lg-9">
        <p-select [style]="{'min-width':'250px'}" [options]="selectedOptionsForCell" [(ngModel)]="selectedAnswerOptionIdList" optionLabel="label" [disabled]="readonly"
              (onChange)="answerSelected($event)"></p-select>
      </div>
    <!-- </ng-container> -->
  </div>
  <span class="questionFooter" [innerHTML]="questionData.footerText"></span>
</div>
